import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#1F1F1F",
        secondary: "#262626",
        accent: "#FF6A00",
        error: "#FF5252",
        info: "#2196F3",
        success: "#2FA84F",
        warning: "#d14200",
      },
      dark: {
        primary: "#FF6A00",
        secondary: "#262626",
        accent: "#FF6A00",
        error: "#FF5252",
        info: "#2196F3",
        success: "#2FA84F",
        warning: "#FFC107",
      },
    },
  },
});
